import { AttendanceFilterOptionValue, FilterKey } from '@studyportals/search-filters';
import { FilterSelectionState } from '@/filters/selection/FilterSelectionState';
import { CountryPresenter } from '@/presenters/CountryPresenter';
import { SeoHeadingHandlerDefaultSorting } from '../SeoHeadingHandlerDefaultSort';

export default class CountryAttendanceOnline extends SeoHeadingHandlerDefaultSorting {
	protected async canHandleWithDefaultSorting(filterSelectionState: FilterSelectionState): Promise<boolean> {
		return (
			(await this.singleSelectionFor(FilterKey.COUNTRY, filterSelectionState)) &&
			(await this.singleSelectionFor(FilterKey.DELIVERY_METHOD, filterSelectionState)) &&
			this.getFilterOptionValueBy(FilterKey.DELIVERY_METHOD, filterSelectionState) ===
				AttendanceFilterOptionValue.ONLINE
		);
	}

	protected async selfHandle(filterSelectionState: FilterSelectionState): Promise<string> {
		const demonym =
			CountryPresenter.demonymOf(this.getFilterOptionValueBy(FilterKey.COUNTRY, filterSelectionState) ?? '') ?? '';

		const seoInfo = `Study online at these ${demonym} universities`;

		return Promise.resolve(seoInfo);
	}
}
